import type { PublicSearchKey } from '@/i18n/dictionaries/publicSearch';

/** The bundle keys the API returns, as dictionary keys. */
const TYPE_LABELS: Partial<Record<string, PublicSearchKey>> = {
  'search.type.news': 'typeNews',
  'search.type.article': 'typeArticle',
  'search.type.policy': 'typePolicy',
  'search.type.page': 'typePage',
  'search.type.advisor_profile': 'typeAdvisor',
  'search.type.library_resource': 'typeLibrary',
  'search.type.organization': 'typeOrganization',
  'search.type.event': 'typeEvent',
  'search.type.research_project': 'typeResearch',
  'search.type.funding_measure': 'typeFunding',
  'search.type.training_session': 'typeTraining',
};

/**
 * The label of a hit's type: the bundle key the API returns, as this page's dictionary key. A type
 * this map does not know yet is shown as a page, the most general word there is.
 */
export function searchTypeKey(typeKey: string): PublicSearchKey {
  return TYPE_LABELS[typeKey] ?? 'typePage';
}
